const localUser = () => {
  return JSON.parse(localStorage.getItem("__crrntUser"))
}
const user = (state) => state.user

export default {
  localUser,
  user
}
